import { ReactElement, useEffect, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { DEFAULT_FORM_VALUES } from './constants';
import { FormContent } from './FormContent';
import { Form } from './styles';
import { DamScheduleFormValues } from './types';

interface DamScheduleFormProps {
  type: 'schedule' | 'exception';
  onCancel: () => void;
  onSuccess: (data: DamScheduleFormValues, type: 'schedule' | 'exception') => void;
  defaultValues?: DamScheduleFormValues;
}

export function DamScheduleForm({
  defaultValues,
  type,
  onCancel,
  onSuccess,
}: Readonly<DamScheduleFormProps>): ReactElement {
  const firstRender = useRef(false);
  const methods = useForm<DamScheduleFormValues>({
    defaultValues: defaultValues ?? DEFAULT_FORM_VALUES,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  function onSubmit(data: DamScheduleFormValues): void {
    onSuccess(data, type);
  }

  useEffect(() => {
    if (defaultValues && !firstRender.current) {
      firstRender.current = true;
      methods.reset(defaultValues);
    }
  }, [defaultValues]);

  return (
    <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <FormContent
          isEdit={!!defaultValues}
          type={type}
          onCancel={onCancel}
        />
      </Form>
    </FormProvider>
  );
}
